export const EditorVersion = '1.3.3'
export const MinimumRequiredVersion = '1.3.3' // Version with src-based image matching fix
